import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import { FiCheck } from "react-icons/fi";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <img src="/main/main1.webp" alt="New Collection" />
        </div>
        <div className="hero-content">
          <span className="subtitle">NEW COLLECTION</span>
          <h1>ESBEN will elevate your cabinets.</h1>
          <p>
            Where spherical forms meet clean lines, ESBEN brings visual and
            tactile joy to your fronts.
          </p>
          <div className="hero-buttons">
            <Link to="/shop" className="btn btn-primary" onClick={toTop}>
              Shop New In
            </Link>
            <Link to="/shop" className="btn btn-secondary" onClick={toTop}>
              All Cabinet Hardware
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Features Banner */}
      <section className="features-banner">
        <div className="container">
          <div className="feature-item">
            <h3>Quality Materials</h3>
            <p>
              Largely crafted from solid brass, our products are built for
              longevity.
            </p>
          </div>
          <div className="feature-item">
            <h3>Celebrated Designs</h3>
            <p>Our award-winning hardware is designed in our London studio.</p>
          </div>
          <div className="feature-item">
            <h3>First-Class Service</h3>
            <p>
              From expert knowledge to speedy shipping, we're committed to your
              project.
            </p>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="categories-section">
        <div className="container">
          <div className="section-header">
            <h2>Decorative details for discerning spaces.</h2>
            <p>
              From statement silhouettes to subtle accents, each product is
              meticulously designed to add character to well-informed homes.
            </p>
          </div>
          <div className="categories-grid">
            <div className="category-card">
              <div className="card-image">
                <img src="/main/main2-1.jpg" alt="Knobs & Handles" />
              </div>
              <h3>Knobs & Handles</h3>
            </div>
            <div className="category-card">
              <div className="card-image">
                <img src="/main/main2-2.webp" alt="Switches and Sockets" />
              </div>
              <h3>Switches and Sockets</h3>
            </div>
            <div className="category-card">
              <div className="card-image">
                <img src="/main/main2-3.webp" alt="Lighting" />
              </div>
              <h3>Lighting</h3>
            </div>
            <div className="category-card">
              <div className="card-image">
                <img src="/main/main2-4.webp" alt="Hooks" />
              </div>
              <h3>Hooks</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Designs Section */}
      <section className="latest-designs">
        <div className="container">
          <div className="section-header">
            <h2>Our latest designs.</h2>
          </div>
          <div className="products-grid">
            {productData.slice(0, 5).map((product, index) => (
              <Link
                to={`/shopDetails/${product.id}`}
                className="product-card"
                key={index}
                onClick={toTop}
              >
                <div className="product-image">
                  <span className="badge badge-blue">NEW FINISH</span>
                  <img src={product.images[0]} alt="PEYTON Oval Knob" />
                </div>
                <div className="product-info">
                  <h4>{product.name}</h4>
                  <p className="price">${product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Story Banner */}
      <section className="story-banner">
        <div className="container">
          <div className="story-content">
            <h2>Designed for detail obsessives.</h2>
            <div className="story-text">
              <p>
                For us, it's the finer details that make a space truly special.
                We're obsessed with how the smallest choices shape the mood of a
                room — from proportion to finish.
              </p>
              <p>
                Inspired by modern design culture, architecture and evolving
                interiors, our collections are made to create mini design
                moments that will elevate your project.
              </p>
              <Link to="/about" className="story-link" onClick={toTop}>
                Read Our Story
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Finish Section */}
      <section className="finish-section">
        <div className="container">
          <div className="section-header">
            <h2>Start with the finish.</h2>
            <p>
              The most accomplished projects start with the final touches.
              Explore our range of sophisticated finishes.
            </p>
          </div>
          <div className="finish-grid">
            <div className="finish-card">
              <img src="/main/main3-1.webp" alt="Satin Brass" />
              <div className="finish-info">
                <span className="finish-style">Lightly Brushed</span>
                <h4>Satin Brass</h4>
              </div>
            </div>
            <div className="finish-card">
              <img src="/main/main3-2.webp" alt="Antique Brass" />
              <div className="finish-info">
                <span className="finish-style">A Vintage Touch</span>
                <h4>Antique Brass</h4>
              </div>
            </div>
            <div className="finish-card">
              <img src="/main/main3-3.webp" alt="Heirloom Brass" />
              <div className="finish-info">
                <span className="finish-style">Lived In</span>
                <h4>Heirloom Brass</h4>
              </div>
            </div>
            <div className="finish-card">
              <img src="/main/main3-4.webp" alt="Blackened Bronze" />
              <div className="finish-info">
                <span className="finish-style">Rich & Warm</span>
                <h4>Blackened Bronze</h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shipping Info Banner */}
      <section className="shipping-banner">
        <div className="container">
          <div className="shipping-item">Free Shipping Over £75+</div>
          <div className="shipping-item">60 Day Returns</div>
          <div className="shipping-item">Over 3,000 5* Reviews</div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="blog-section">
        <div className="container">
          <div className="section-header">
            <span className="subtitle">New Blog Articles</span>
            <h2>Take a Tea Break.</h2>
            <p>
              Inspiration, education and motivation — for those "tools-down"
              moments.
            </p>
          </div>
          <div className="blog-grid">
            <div className="blog-card">
              <div className="blog-image">
                <img src="/main/main5-1.webp" alt="Blog 1" />
                <div className="blog-overlay-text">
                  <h3>How to Choose Light Switches & Plug Sockets.</h3>
                </div>
              </div>
              <div className="blog-content">
                <span className="category">HOW-TO</span>
                <h4>
                  How to Choose Light Switches and Sockets: Finishes, styles &
                  What Actually Matters
                </h4>
                <p className="date">May 14, 2026</p>
              </div>
            </div>
            <div className="blog-card">
              <div className="blog-image">
                <img src="/main/main5-2.webp" alt="Blog 2" />
              </div>
              <div className="blog-content">
                <span className="category">HOW-TO</span>
                <h4>
                  How to Use Oversized Appliance Pulls (And Where They Actually
                  Work Best)
                </h4>
                <p className="date">Apr 14, 2026</p>
              </div>
            </div>
            <div className="blog-card">
              <div className="blog-image">
                <img src="/main/main5-3.webp" alt="Blog 3" />
                <div className="blog-overlay-handwritten">
                  <span>Obsessed with the details</span>
                </div>
              </div>
              <div className="blog-content">
                <span className="category">INSPIRATION</span>
                <h4>Obsessed with the Details: Edition 1</h4>
                <p className="date">Mar 20, 2026</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="reviews-section">
        <div className="container">
          <div className="reviews-carousel">
            <h2>
              4,000+ 5 star reviews on <strong>yotpo.</strong>
            </h2>

            <div className="carousel-container">
              <div className="review-slide">
                <p className="review-text">
                  "The product is wonderful, very high quality. The customer
                  service response was super fast and the delivery of the pieces
                  I needed took only a couple of days. I can't say enough about
                  this company!"
                </p>
                <p className="review-author">Julie Anderson</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partner Section */}
      <section className="partner-section">
        <div className="container">
          <div className="partner-grid">
            <div className="partner-image">
              <img src="/main/main4.webp" alt="Trade Partner" />
            </div>
            <div className="partner-content">
              <span className="subtitle">Apply For A Trade Account</span>
              <h2>We partner with Pro' Designers & Makers.</h2>
              <p>
                Everything you need to specify hardware clearly, quickly, and
                with confidence.
              </p>
              <ul className="partner-features">
                <li>
                  <FiCheck /> Discounted Pricing
                </li>
                <li>
                  <FiCheck /> Dedicated Support
                </li>
                <li>
                  <FiCheck /> Express Delivery
                </li>
                <li>
                  <FiCheck /> Product Samples
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Main;
